<template>
  <div
    class="tree-node"
    :class="
      'tree-node__level' +
      level +
      (!node.leaf && !node.expand ? ' closed' : '') +
      (node.leaf && node.id == selected ? ' active' : '')
    "
  >
    <template v-if="!node.leaf">
      <div class="tree-node__item tree-node__parent">
        <a
          href="javascript:;"
          class="tree-node__link"
          @click.prevent="expandNode(node)"
        >
          <span class="tree-node__toggle"></span>
          <span class="tree-node__text">{{ node.text }}</span>
        </a>
      </div>
      <div class="tree-node__children">
        <tree-node
          v-for="child in node.children"
          :key="child.id"
          :node="child"
          :level="level + 1"
          :selected="selected"
          @expand="expandNode(child)"
          @select="selectNode(child)"
        />
      </div>
    </template>
    <template v-else>
      <div class="tree-node__item">
        <a
          href="javascript:;"
          class="tree-node__link"
          @click.prevent="selectNode(node)"
        >
          <span class="tree-node__text">{{ node.text }}</span>
        </a>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "TreeNode",
  props: {
    level: Number,
    selected: Number,
    node: Object,
  },
  methods: {
    expandNode(node) {
      this.$emit("expand", node);
    },
    selectNode(node) {
      const me = this;
      if (me.level) {
        me.$parent.selectNode(node);
      } else {
        me.$emit("select", node);
      }
    },
  },
};
</script>